import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

import { formatThousands } from '~/utils/helpers'

interface Props {
  title: string
  accuracy: number
  bestStreak: number
  score: number
  imgSrcKey: string
}

const mediaQuerySummary = [{ screen: '(min-width: 280px)', width: '32px' }]

function SummaryDetails({
  value,
  imgSrcKey,
  title,
}: {
  value: number
  imgSrcKey: string
  title: string
}): React.ReactElement {
  return (
    <div className="flex items-center">
      <ResponsiveImage
        alt={title}
        imageWidths="32"
        mediaQuery={mediaQuerySummary}
        srcKey={`scoreboard/${imgSrcKey}`}
        width={32}
      />
      <span className="text-sm ml-2 font-medium">
        {title}: {formatThousands(value)}
      </span>
    </div>
  )
}

const mediaQueryMultGame = [{ screen: '(min-width: 280px)', width: '28px' }]
export default function MultGameSurvivalSprint({
  title,
  accuracy,
  bestStreak,
  score,
  imgSrcKey,
}: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  return (
    <div className="w-full">
      <div className="flex items-center justify-center mb-4">
        <ResponsiveImage alt={title} imageWidths="28" mediaQuery={mediaQueryMultGame} srcKey={imgSrcKey} width={28} />
        <span className="text-md lg:text-lg ml-4 font-medium lg:font-semibold">{title}</span>
      </div>

      <div className="flex lg:justify-between justify-center items-center flex-wrap">
        <SummaryDetails imgSrcKey="mult game trophy.svg" title={t('multGame.score')} value={score} />
        <div className="w-full lg:w-[62.5%] flex justify-between items-center mt-2 lg:mt-0">
          <SummaryDetails imgSrcKey="fire.svg" title={t('multGame.bestStreak')} value={bestStreak} />
          <SummaryDetails imgSrcKey="multgame_accuracy.svg" title={t('multGame.accuracy')} value={accuracy} />
        </div>
      </div>

      <div className="my-4 w-full h-0.5 bg-purple-light" />
    </div>
  )
}
